function sleep(t: number) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), t)
  })
}

function cancellableSleep(t: number) {
  let resolve: () => void
  let reject: () => void
  const promise = new Promise<void>((_resolve, _reject) => {
    resolve = _resolve
    reject = _reject
  })
  const timer = setTimeout(() => {
    resolve()
  }, t)
  const cancel = () => {
    clearTimeout(timer)
    resolve()
  }
  const abort = () => {
    clearTimeout(timer)
    reject()
  }
  return { promise, cancel, abort }
}

export const time = {
  sleep,
  cancellableSleep,
}
